import { environment } from '../../environments/environment';

// Requests to the API's service
export const APIServices = {
  common: {
    getUserServices: environment.commonServices + '/api/SelectList/UserServices',
    GetUserRoles: environment.commonServices + '/api/SelectList/GetUserRoles',
    UserServicesAndAll: environment.commonServices + '/api/SelectList/UserServicesAndAll',
    getEmitterByServ: environment.commonServices + '/api/SelectList/EmitterByServ',
    GetMenuByUser: environment.commonServices + '/api/Menu/GetMenuByUserId',
    getPermissionForPage: environment.commonServices + '/api/Menu/getPermissionForPage',
    GetListMaterialType: environment.commonServices + '/api/SelectList/GetListMaterialType',
    GetContractCustomerServices: environment.commonServices + '/api/SelectList/ContractCustomerServices',
    GetValidationType: environment.commonServices + '/api/SelectList/GetValidationType',
    GetConditionPay: environment.commonServices + '/api/SelectList/GetConditionPay',
    GetLocalLanguages: environment.commonServices + '/api/SelectList/GetLocalLanguages',
    GetCountries: environment.commonServices + '/api/SelectList/GetCountries',
    GetCountriesByServ: environment.commonServices + '/api/SelectList/GetCountriesByServ',
    GetAllRolesList : environment.commonServices + '/api/SelectList/GetAllRolesList',
    GetRolesListWithAll : environment.commonServices + '/api/SelectList/GetRolesListWithAll',

    GetOriginCountries: environment.commonServices + '/api/SelectList/GetOriginCountries',
    GetClieType: environment.commonServices + '/api/SelectList/GetClieType',


    GetRegionByCountry: environment.commonServices + '/api/SelectList/GetRegionByCountry',
    GetRegionByServ: environment.commonServices + '/api/SelectList/GetRegionByServ',
    GetProvinceByRegion: environment.commonServices + '/api/SelectList/GetProvinceByRegion',
    GetProvinceByServ: environment.commonServices + '/api/SelectList/GetProvinceByServ',
    GetMuniByProvince: environment.commonServices + '/api/SelectList/GetMuniByProvince',
    GetMuniByServ: environment.commonServices + '/api/SelectList/GetMuniByServ',
    GetDataTypeSelectList: environment.commonServices + '/api/SelectList/GetDataTypeSelectList',
    GetNuclByMuni: environment.commonServices + '/api/SelectList/GetNuclByMuni',
    GetViaAut: environment.commonServices + '/api/SelectList/GetViaAut',

    GetViasByServiceCountryRegionProvince: environment.commonServices + '/api/SelectList/GetViasByServiceCountryRegionProvince',

    GetCpByVia: environment.commonServices + '/api/SelectList/GetCpByVia',

    GetViaType: environment.commonServices + '/api/SelectList/GetViaType',
    GetImpType: environment.commonServices + '/api/SelectList/GetImpType',
    GetSpecialTypePrecVent: environment.commonServices + '/api/SelectList/GetSpecialTypePrecVent',
    GetLatestYear: environment.commonServices + '/api/SelectList/GetLatestYear',
    GetFutureYears: environment.commonServices + '/api/SelectList/GetFutureYears',
    GetMonths: environment.commonServices + '/api/SelectList/GetMonths',
    GetInvoicesType: environment.commonServices + '/api/SelectList/GetInvoicesType',
    GetInstType: environment.commonServices + '/api/SelectList/GetInstType',
    GetDocsType: environment.commonServices + '/api/SelectList/GetDocsType',
    GetAllBox: environment.commonServices + '/api/SelectList/GetAllBox',

    GetBudgetType: environment.commonServices + '/api/SelectList/GetBudgetType',

    GetPvGrupoType: environment.commonServices + '/api/SelectList/GetPvGrupoType',
    GetZoneList : environment.commonServices + '/api/SelectList/GetZoneList' ,
    GetDelegationsList : environment.commonServices + '/api/SelectList/GetDelegationsList',
    GetAllServices : environment.commonServices + '/api/SelectList/GetAllServicesList',
    GetWarehouses : environment.commonServices + '/api/SelectList/GetWarehousesList',
    GetRolesListByType : environment.commonServices + '/api/SelectList/GetRolesListByType',
    GetOperatorsList : environment.commonServices + '/api/SelectList/GetOperatorsList',
    GetRoleTypesList : environment.commonServices + '/api/SelectList/GetRoleTypesList',
    GetNormativesList: environment.commonServices + '/api/SelectList/GetNormativesList',
    cataMaes: {
      GetCataMaesGrid: environment.commonServices + '/api/CataMaes/GetCataMaesGrid',
      getListInventoryGrid: environment.commonServices + '/api/CataMaes/GetListInventoryGrid'
    },
    UserInfo: environment.commonServices + '/api/UserInfo/UserInfo',

    GetFullDire: environment.commonServices + '/api/GrDire/GetFullDire',

    grid: {
      GetFilterByGridNameAndUserId: environment.commonServices + '/api/Grid/GetFilterByGridNameAndUserId',
      CreateOrUpdateGridFilter: environment.commonServices + '/api/Grid/CreateOrUpdateGridFilter',
      DeleteGridFilter: environment.commonServices + '/api/Grid/DeleteGridFilter',
      UpdateSelectedGridFilter: environment.commonServices + '/api/Grid/UpdateSelectedGridFilter',
    },
  },
  nota: {
    budgets: {
      GetConceptType: environment.notaServices + '/api/Budget/GetConceptType',
      SelectList: {
        GetBudgetStatesServices: environment.notaServices + '/api/Budget/BudgetSelectList/BudgetStatesServices',
        GetBudgetStatesServicesByCurrentState: environment.notaServices + '/api/Budget/BudgetSelectList/BudgetStatesServicesByCurrentState',
        GetDocumentTypeOfBudgetServices: environment.notaServices + '/api/Budget/BudgetSelectList/DocumentTypeOfBudgetServices',
        GetSpecialCustomerTypeOfBudgetServices: environment.notaServices + '/api/Budget/BudgetSelectList/SpecialCustomerTypeOfBudgetServices',
        GetBudgetTypesByServices: environment.notaServices + '/api/Budget/BudgetSelectList/BudgetTypesByServices',
        GetOTsByBudget: environment.notaServices + '/api/Budget/BudgetSelectList/GetOTsByBudget',
        GetUnidMedida: environment.notaServices + '/api/Budget/BudgetSelectList/GetUnidMedida',
        GetUserAndBudgetServices: environment.notaServices + '/api/Budget/BudgetSelectList/GetUserAndBudgetServices',
      },
      OT: {
        searchOTByBudgetAndService: environment.notaServices + '/api/Budget/SearchOTByBudgetAndService',
        associatedWithABudget: environment.notaServices + '/api/Budget/AssociatedWithABudget',
        disassociateOTAndBudget: environment.notaServices + '/api/Budget/DisassociateOTAndBudget',
        newOTAssociateBudget: environment.notaServices + '/api/Budget/NewOTAssociateBudget'
      },
      PhotoDetail: {
        getPhotoDetailGrid: environment.notaServices + '/api/Budget/BudgetPhotoDetail/GetGridData',
        GetPhotoDetail: environment.notaServices + '/api/Budget/BudgetPhotoDetail/GetPhotoDetail',
        SavePhotoDetail: environment.notaServices + '/api/Budget/BudgetPhotoDetail/SavePhotoDetail',
        DeletePhotoDetail: environment.notaServices + '/api/Budget/BudgetPhotoDetail/DeletePhotoDetail',
        EditPhotoDetail: environment.notaServices + '/api/Budget/BudgetPhotoDetail/EditPhotoDetail'
      },
      Documentation: {
        GetGridData: environment.notaServices + '/api/Budget/BudgetDocumentation/GetGridData',
        GetDocument: environment.notaServices + '/api/Budget/BudgetDocumentation/GetDocument',
        SaveDocument: environment.notaServices + '/api/Budget/BudgetDocumentation/SaveDocument',
        DeleteDocument: environment.notaServices + '/api/Budget/BudgetDocumentation/DeleteDocument',
        EditDocument: environment.notaServices + '/api/Budget/BudgetDocumentation/EditDocument',
        CheckDocumentValidation: environment.notaServices + '/api/Budget/BudgetDocumentation/CheckDocumentValidation'
      },
      payments: {
        addBudgetPayment: environment.notaServices + '/api/Budget/AddBudgetPayment'
      },
      bills: {
        getBudgetBillingTypeActionsOrMessages: environment.notaServices + '/api/Budget/GetBudgetBillingTypeActionsOrMessages',
        getBudgetListInvoicesByBudgetId: environment.notaServices + '/api/Budget/GetBudgetListInvoicesByBudgetId',
        addBillToBudgetFromBillsTab: environment.notaServices + '/api/Budget/AddBillToBudgetFromBillsTab',
        budgetElaborationBilling: environment.notaServices + '/api/Budget/BudgetElaborationBilling'
      },
      getBudgetsGrid: environment.notaServices + '/api/Budget/GetGridData',
      SearchAcoByServ: environment.notaServices + '/api/Budget/SearchAcoByServ',
      getBudgetDetailBusinessRules: environment.notaServices + '/api/Budget/BudgetDetailBusinessRules',
      DoubleBudget: environment.notaServices + '/api/Budget/DoubleBudget',
      saveBudgetDetail: environment.notaServices + '/api/Budget/SaveBudgetDetail',
      searchBudgetDetailById: environment.notaServices + '/api/Budget/SearchBudgetDetailById',
      getAggregateBudgetTotalValue: environment.notaServices + '/api/Budget/GetAggregateTotalValue',
      getBudgetImpByMatOrConcetAndServ: environment.notaServices + '/api/Budget/GetBudgetImpByMatOrConcetAndServ',
      saveBudgetLine: environment.notaServices + '/api/Budget/SaveBudgetLine',
      deleteBudgetLine: environment.notaServices + '/api/Budget/DeleteBudgetLine',
      validateBudget: environment.notaServices + '/api/Budget/ValidateBudget',
      searchCustomerSpecialTypeByCustomerId: environment.notaServices + '/api/Budget/SearchCustomerSpecialTypeByCustomerId',
      searchLinesInfo: environment.notaServices + '/api/Budget/SearchLinesInfo',
      getBudgetLineInfo: environment.notaServices + '/api/Budget/GetBudgetLineInfo',
      getAggregateTotalValue: environment.notaServices + '/api/Budget/GetAggregateTotalValue',
      searchBudgetPaymentInfo: environment.notaServices + '/api/Budget/SearchBudgetPaymentInfo',
      PrintBudget: environment.notaServices + '/api/Budget/PrintBudget',
      PrintBudgetAndalusianFormat: environment.notaServices + '/api/Budget/PrintBudgetAndalusianFormat',
      GetBudgetInfoSC: environment.notaServices + '/api/Budget/GetBudgetInfoSC',
      searchInstallationInfo: environment.notaServices + '/api/Budget/SearchInstallationInfo',
      GetBudgetInfoFromClient: environment.notaServices + '/api/Budget/GetBudgetInfoFromClient',
      numberAdditionalBudgetLinesByBudgetIdAndBudgetType: environment.notaServices + '/api/Budget/NumberAdditionalBudgetLinesByBudgetIdAndBudgetType',
      budgetIsInFinalState: environment.notaServices + '/api/Budget/BudgetIsInFinalState'
    },
    billing: {
      SelectList: {
        GetBillTypeList: environment.notaServices + '/api/Billing/SelectList/GetBillTypeList',
        getBillStateList: environment.notaServices + '/api/Billing/SelectList/GetBillStateList',
        getEspecialCustomerTypeList: environment.notaServices + '/api/Billing/SelectList/GetEspecialCustomerTypeList',
        GetFixedTextTypeList: environment.notaServices + '/api/Billing/SelectList/GetFixedTextTypeList',
        GetPaymentMethodList: environment.notaServices + '/api/Billing/SelectList/GetPaymentMethodList',
        GetIvaTypeList: environment.notaServices + '/api/Billing/SelectList/GetIvaTypeList',
        GetBankAccountList: environment.notaServices + '/api/Billing/SelectList/GetBankAccountList',
        GetPaymentOptionsList: environment.notaServices + '/api/Billing/SelectList/GetPaymentOptionsList',
        GetPaymentsByBillingId: environment.notaServices + '/api/Billing/SelectList/GetPaymentsByBillingId',
        GetPrintServiceInfo: environment.notaServices + '/api/Billing/SelectList/GetPrintServiceInfo'
      },
      payments: {
        getUnpaidBillsInfo: environment.notaServices + '/api/Billing/GetUnpaidBillsInfo',
        getPaymentPlanNumberByService: environment.notaServices + '/api/Billing/GetPaymentPlanNumberByService',
        generateExpirationsAgreement: environment.notaServices + '/api/Billing/GenerateExpirationsAgreement',
        saveNewPaymentPlan: environment.notaServices + '/api/Billing/SaveNewPaymentPlan',
        invoiceGetLatestPaymentPlanCustomer: environment.notaServices + '/api/Billing/InvoiceGetLatestPaymentPlanCustomer',
        getPaymentsPlanGeneratedInfo: environment.notaServices + '/api/Billing/GetPaymentsPlanGeneratedInfo',
        getPaymentsPlanByServiceAndCustomer: environment.notaServices + '/api/Billing/GetPaymentsPlanByServiceAndCustomer',
        getPaymentsPlanGeneratedTotalAmount: environment.notaServices + '/api/Billing/GetPaymentsPlanGeneratedTotalAmount',
        getPaymentsPlanByServiceClientAndPayPlan: environment.notaServices + '/api/Billing/GetPaymentsPlanByServiceClientAndPayPlan',
        getPaymentsPlanByServiceClientAndPayPlan_PendingFees: environment.notaServices + '/api/Billing/GetPaymentsPlanByServiceClientAndPayPlan_PendingFees',
        getPaymentsPlanByServiceClientAndPayPlan_PaidOut: environment.notaServices + '/api/Billing/GetPaymentsPlanByServiceClientAndPayPlan_PaidOut',
        getPaymentsPlanAmounts: environment.notaServices + '/api/Billing/GetPaymentsPlanAmounts',
        getPaymentsPlanInfoForBill: environment.notaServices + '/api/Billing/GetPaymentsPlanInfoForBill',
        getFeesPendingPaymentPlanPayment: environment.notaServices + '/api/Billing/GetFeesPendingPaymentPlanPayment',
        saveNewPayment: environment.notaServices + '/api/Billing/SaveNewPayment',
        annulPaymentPlan: environment.notaServices + '/api/Billing/AnnulPaymentPlan',
        cancelPaymentPlan: environment.notaServices + '/api/Billing/CancelPaymentPlan',
        printRecognitionDebtAndPaymentPlan: environment.notaServices + '/api/Billing/PrintRecognitionDebtAndPaymentPlan',
        printProofPaymentPPBill: environment.notaServices + '/api/Billing/PrintProofPaymentPPBill'
      },
      Documentation: {
        GetGridData: environment.notaServices + '/api/Billing/BillingDocumentation/GetGridData',
        GetDocument: environment.notaServices + '/api/Billing/BillingDocumentation/GetDocument',
        SaveDocument: environment.notaServices + '/api/Billing/BillingDocumentation/SaveDocument',
        DeleteDocument: environment.notaServices + '/api/Billing/BillingDocumentation/DeleteDocument',
        EditDocument: environment.notaServices + '/api/Billing/BillingDocumentation/EditDocument',
        CheckDocumentValidation: environment.notaServices + '/api/Billing/BillingDocumentation/CheckDocumentValidation'
      },
      getBillingGrid: environment.notaServices + '/api/Billing/GetGridData',
      GetBillingDetail: environment.notaServices + '/api/Billing/GetBillingDetail',
      SaveBillingDetail: environment.notaServices + '/api/Billing/SaveBillingDetail',
      GetLineGridData: environment.notaServices + '/api/Billing/GetLineGridData',
      SaveBillLine: environment.notaServices + '/api/Billing/SaveBillLine',
      DeleteBillLine: environment.notaServices + '/api/Billing/DeleteBillLine',
      GetBillLineInfo: environment.notaServices + '/api/Billing/GetBillLineInfo',
      GetImpByMatOrConcetAndServ: environment.notaServices + '/api/Billing/GetImpByMatOrConcetAndServ',
      GetAggregateTotalValue: environment.notaServices + '/api/Billing/GetAggregateTotalValue',
      GetExpirationGridData: environment.notaServices + '/api/Billing/GetExpirationGridData',
      GetBillExpirationInfo: environment.notaServices + '/api/Billing/GetBillExpirationInfo',
      GeneratePaymentPlan: environment.notaServices + '/api/Billing/GeneratePaymentPlan',
      GetBillingPaymentInfo: environment.notaServices + '/api/Billing/GetBillingPaymentInfo',
      SaveBillingPayment: environment.notaServices + '/api/Billing/SaveBillingPayment',
      PrintBill: environment.notaServices + '/api/Billing/PrintBill',
      EmitBillingDetail: environment.notaServices + '/api/Billing/EmitBillingDetail',
      GetPaymentPlanInfo: environment.notaServices + '/api/Billing/GetPaymentPlanInfo',
      RectifyBill: environment.notaServices + '/api/Billing/RectifyBill',
      GetLineGridDataRect: environment.notaServices + '/api/Billing/GetLineGridDataRect',
      RectifyBillLine: environment.notaServices + '/api/Billing/RectifyBillLine',
      PrintPayment: environment.notaServices + '/api/Billing/PrintPayment',
      CheckCancelPayment: environment.notaServices + '/api/Billing/CheckCancelPayment',
      CheckServiceFraude: environment.notaServices + '/api/Billing/CheckServiceFraude',
      CancelBillingPayment: environment.notaServices + '/api/Billing/CancelBillingPayment',
      GetHistStatesGrid: environment.notaServices + '/api/Billing/GetHistStatesGrid',
      CheckMultiEmiterAndGeneratePaymentPlan: environment.notaServices + '/api/Billing/CheckMultiEmiterAndGeneratePaymentPlan',
      GenerateMultiEmiterPaymentPlan: environment.notaServices + '/api/Billing/GenerateMultiEmiterPaymentPlan',
      EmitAllBudgetBills: environment.notaServices + '/api/Billing/EmitAllBudgetBills',
      GetExpirationMultiEmiterGrid: environment.notaServices + '/api/Billing/GetExpirationMultiEmiterGrid',
      CheckMultiEmiter: environment.notaServices + '/api/Billing/CheckMultiEmiter',
      GetBillFromClient: environment.notaServices + '/api/Billing/GetBillFromClient',
      DiversaSearchDire: environment.notaServices + '/api/Billing/DiversaSearchDire',
      DiversaSearchExpedient: environment.notaServices + '/api/Billing/DiversaSearchExpedient',
      GetUserAndBillServices: environment.notaServices + '/api/Billing/GetUserAndBillServices'
    },
    charges: {

    },
    customers: {
      getCustomersGrid: environment.notaServices + '/api/Customers/GetGridData',
      GetInfoCustomer: environment.notaServices + '/api/Customers/GetInfoCustomer',
      CheckCustomer: environment.notaServices + '/api/Customers/CheckCustomer',
      GetInfoCustomerServ: environment.notaServices + '/api/Customers/GetInfoCustomerServ',
      GetViaAut: environment.notaServices + '/api/Customers/GetViaAut',
      ValidateNIF_CIF_NIE: environment.notaServices + '/api/Customers/ValidateNIF_CIF_NIE',
      GetGridPublicCustomerByNif: environment.notaServices + '/api/Customers/GetGridPublicCustomerByNif',
      GetGridCustomerByNifAndServ: environment.notaServices + '/api/Customers/GetGridCustomerByNifAndServ',
      GetLocationFiscalPublicCustomer: environment.notaServices + '/api/Customers/GetLocationFiscalPublicCustomer',
      GetDescriptionLocationCustomer: environment.notaServices + '/api/Customers/GetDescriptionLocationCustomer',
      CheckEditableForInvoiceStates: environment.notaServices + '/api/Customers/CheckEditableForInvoiceStates',
      InsertNewLocationAut: environment.notaServices + '/api/Customers/InsertNewLocationAut',
      insertConfigGrid: environment.notaServices + '/api/Customers/insertConfigGrid',
      GetConfigGrid: environment.notaServices + '/api/Customers/GetConfigGrid',
      GetAllConfigGrid: environment.notaServices + '/api/Customers/GetAllConfigGrid',
      GetUserAndCustomerServices: environment.notaServices + '/api/Customers/GetUserAndCustomerServices',

      InsertNewLocationDiversa: environment.notaServices + '/api/Customers/InsertNewLocationDiversa',
      GetBudgetsGridCustomer: environment.notaServices + '/api/Customers/GetBudgetsGridCustomer',
      GetBillingGridCustomer: environment.notaServices + '/api/Customers/GetBillingGridCustomer',
      InsertNewCustomerClie: environment.notaServices + '/api/Customers/InsertNewCustomerClie',
      InsertNewCustomerClieServ: environment.notaServices + '/api/Customers/InsertNewCustomerClieServ',
      UpdateNewCustomerClie: environment.notaServices + '/api/Customers/UpdateNewCustomerClie',
      UpdateNewCustomerClieServ: environment.notaServices + '/api/Customers/UpdateNewCustomerClieServ',
      ValidateIBAN: environment.notaServices + '/api/Customers/ValidateIBAN',
      GetPostalCode: environment.notaServices + '/api/Customers/GetPostalCode',
      GetManagementUnit: environment.notaServices + '/api/Customers/GetManagementUnit',
      GetAccountingOfice: environment.notaServices + '/api/Customers/GetAccountingOfice',
      GetProcessingUnit: environment.notaServices + '/api/Customers/GetProcessingUnit',
      DiversaSearchContract: environment.notaServices + '/api/Customers/DiversaSearchContract',
      DiversaSearchDire: environment.notaServices + '/api/Customers/DiversaSearchDire',
      SaveNewLocationAndGetInfoDire: environment.notaServices + '/api/Customers/SaveNewLocationAndGetInfoDire',
      CheckDiversaServ: environment.notaServices + '/api/Customers/CheckDiversaServ',
      Documentation: {
        GetGridData: environment.notaServices + '/api/Customers/CustomersDocumentation/GetGridData',
        GetDocument: environment.notaServices + '/api/Customers/CustomersDocumentation/GetDocument',
        SaveDocument: environment.notaServices + '/api/Customers/CustomersDocumentation/SaveDocument',
        DeleteDocument: environment.notaServices + '/api/Customers/CustomersDocumentation/DeleteDocument',
        EditDocument: environment.notaServices + '/api/Customers/CustomersDocumentation/EditDocument',
        CheckDocumentValidation: environment.notaServices + '/api/Customers/CustomersDocumentation/CheckDocumentValidation'
      },
    },
    sales: {
      getSalesGrid: environment.notaServices + '/api/Sales/GetGridData',
      InsertPrecVent: environment.notaServices + '/api/Sales/InsertPrecVent',
      InsertHistory: environment.notaServices + '/api/Sales/InsertHistory',
      UpdatePrecVent: environment.notaServices + '/api/Sales/UpdatePrecVent',
      UpdateHistory: environment.notaServices + '/api/Sales/UpdateHistory',
      GetPrecVent: environment.notaServices + '/api/Sales/GetPrecVent',
      GetHistories: environment.notaServices + '/api/Sales/GetHistories',
      DeletePrecVent: environment.notaServices + '/api/Sales/DeletePrecVent',
      PrintPSales: environment.notaServices + '/api/Sales/PrintPSales',
      GetConceptInfoById: environment.notaServices + '/api/Sales/GetConceptInfoById',
      GetUserAndSalesServices: environment.notaServices + '/api/Sales/GetUserAndSalesServices'

    },
    inbox: {
      GetGridData: environment.notaServices + '/api/Inbox/GetGridData',
      MarkElementAsRead: environment.notaServices + '/api/Inbox/MarkElementAsRead',
      GetDownloadsByUser: environment.notaServices + '/api/Inbox/GetDownloadsByUser',
      getFileToDownload: environment.notaServices + '/api/Inbox/getFileToDownload'
    },
    notice: {
      GetNotices: environment.notaServices + '/api/Notice/GetNotices',
      GetTitleNotice: environment.notaServices + '/api/Notice/GetTitleNotice',
      DeleteNotice: environment.notaServices + '/api/Notice/DeleteNotice',
      getFileToDownloadNotice: environment.notaServices + '/api/Notice/getFileToDownloadNotice'
    },
    reports: {
      GeneralRecordBook: environment.notaServices + '/api/reports/GeneralRecordBook',
      GeneralRecordBookTotal: environment.notaServices + '/api/reports/GeneralRecordBookTotal',
      BebtPerCustomer: environment.notaServices + '/api/reports/BebtPerCustomer',
      ConceptsBilled: environment.notaServices + '/api/reports/ConceptsBilled',
      DailyCash: environment.notaServices + '/api/reports/DailyCash',
      DailyCashTotally: environment.notaServices + '/api/reports/DailyCashTotally',
      BoxGrouping: environment.notaServices + '/api/reports/BoxGrouping',
      BoxGroupingTotally: environment.notaServices + '/api/reports/BoxGroupingTotally',
      GroupingAccountingClosure: environment.notaServices + '/api/reports/GroupingAccountingClosure',
      GroupingAccountingClosureTotally: environment.notaServices + '/api/reports/GroupingAccountingClosureTotally',
      MonthlyRevenueCollection: environment.notaServices + '/api/reports/MonthlyRevenueCollection',
      MonthlyRevenueCollectionTotally: environment.notaServices + '/api/reports/MonthlyRevenueCollectionTotally',
      DailyBank: environment.notaServices + '/api/reports/DailyBank',
      DailyBankTotally: environment.notaServices + '/api/reports/DailyBankTotally',
      MonthlyCollecterPerDay: environment.notaServices + '/api/reports/MonthlyCollecterPerDay',
      MonthlyCollecterPerDayTotally: environment.notaServices + '/api/reports/MonthlyCollecterPerDayTotally',
      ResumeAggregatorOperator: environment.notaServices + '/api/reports/ResumeAggregatorOperator',
      Operator: environment.notaServices + '/api/reports/Operator',
      ConceptAndbox: environment.notaServices + '/api/reports/ConceptAndbox',
      ConceptTotServ: environment.notaServices + '/api/reports/ConceptTotServ',
      PaymentMethodBank: environment.notaServices + '/api/reports/PaymentMethodBank',
      Remittance: environment.notaServices + '/api/reports/Remittance',
      print: {
        printRecordBook: environment.notaServices + '/api/reports/PrintRecordBook',
        printConceptsBilled: environment.notaServices + '/api/reports/PrintConceptsBilled',

        printDailyCash: environment.notaServices + '/api/reports/PrintDailyCash',
        printDebtPerCustomer: environment.notaServices + '/api/reports/PrintDebtPerCustomer',

        printBoxGrouping: environment.notaServices + '/api/reports/PrintBoxGrouping',
        PrintOperatorGrouping: environment.notaServices + '/api/reports/PrintOperatorGrouping',
        printGroupingAccountingClosure: environment.notaServices + '/api/reports/PrintGroupingAccountingClosure',
        printConceptTotalityService: environment.notaServices + '/api/reports/PrintConceptTotalityService',
        printPaymentMethodBank: environment.notaServices + '/api/reports/PrintPaymentMethodBank',
        printMonthlyRevenueCollection: environment.notaServices + '/api/reports/PrintMonthlyRevenueCollection',
        PrintDailyBankCollection: environment.notaServices + '/api/reports/PrintDailyBankCollection',
        PrintMonthlyCollecterPerDay: environment.notaServices + '/api/reports/PrintMonthlyCollecterPerDay',
        PrintConceptAndBox: environment.notaServices + '/api/reports/PrintConceptAndBox',
      }
    },
    facturae: {
      facturae: {
        GetAll: environment.notaServices + '/api/FacturaE/GetAll',
        Get: environment.notaServices + '/api/FacturaE/Get',
        Post: environment.notaServices + '/api/FacturaE/Post',
        GetStatus: environment.notaServices + '/api/FacturaE/GetStatus'
      },
      attachments: {
        GetAll: environment.notaServices + '/api/AttachmentsFacturaE/GetAll',
        Delete: environment.notaServices + '/api/AttachmentsFacturaE/Delete',
        Post: environment.notaServices + '/api/AttachmentsFacturaE/Post',
        Get: environment.notaServices + '/api/AttachmentsFacturaE/Get',
        GetStatus: environment.notaServices + '/api/AttachmentsFacturaE/GetStatus'
      },
      FieldsFacturaE: {
        GetAll: environment.notaServices + '/api/FieldsFacturaE/GetAll',
        Delete: environment.notaServices + '/api/FieldsFacturaE/Delete',
        Post: environment.notaServices + '/api/FieldsFacturaE/Post',
        Get: environment.notaServices + '/api/FieldsFacturaE/Get',
        GetListFields: environment.notaServices + '/api/FieldsFacturaE/GetListFields'
      }
    },
    parametrization: {
      GetGridDocuments: environment.notaServices + '/api/AsociatedDocumentation/GetGridDocuments',
      GetGridAsociatedDocuments: environment.notaServices + '/api/AsociatedDocumentation/GetGridAsociatedDocuments',
      AsociateDocumentToServAndDocType: environment.notaServices + '/api/AsociatedDocumentation/AsociateDocumentToServAndDocType',
      DeleteDocumentToServAndDocType: environment.notaServices + '/api/AsociatedDocumentation/DeleteDocumentToServAndDocType',
      saveAsociatedDocuments: environment.notaServices + '/api/AsociatedDocumentation/saveAsociatedDocuments',
      getCodaServicesByUserId: environment.notaServices + '/api/CalendarForClosingBilling/GetCodaServicesByUserId',
      getAllBillingClosingDatesGrid: environment.notaServices + '/api/CalendarForClosingBilling/GetAllBillingClosingDatesGrid',
      getBillingClosingDate: environment.notaServices + '/api/CalendarForClosingBilling/GetBillingClosingDate',
      insertBillingClosingDate: environment.notaServices + '/api/CalendarForClosingBilling/InsertBillingClosingDate',
      updateBillingClosingDate: environment.notaServices + '/api/CalendarForClosingBilling/UpdateBillingClosingDate',
      getTypesBudgetLinesByUserAndService: environment.notaServices + '/api/Budget/GetTypesBudgetLinesByUserAndService',
      saveNewParametrizationBudgetTypeForm: environment.notaServices + '/api/Budget/SaveNewParametrizationBudgetTypeForm',
      updateParametrizationBudgetTypeForm: environment.notaServices + '/api/Budget/UpdateParametrizationBudgetTypeForm',
      deleteParametrizationBudgetTypeForm: environment.notaServices + '/api/Budget/DeleteParametrizationBudgetTypeForm',
      BudgetValidityDays: environment.notaServices + '/api/BudgetValidityDays/GetGridData',
      UpdateParametrizationBudgetValidity: environment.notaServices + '/api/BudgetValidityDays/UpdateParametrizationBudgetValidity',
      GetGridPaymentsMethods: environment.notaServices + '/api/PaymentsMethods/GetGridPaymentsMethods',
      savePaymentsMethods: environment.notaServices + '/api/PaymentsMethods/savePaymentsMethods',
      BankAccount:{
        GetListIBAN: environment.notaServices + '/api/BankAccount/GetBankAccountListIBAN',
        Insert : environment.notaServices + '/api/BankAccount/InsertBankAccount' ,
        Update:  environment.notaServices + '/api/BankAccount/UpdateBankAccount' ,
        Delete : environment.notaServices + '/api/BankAccount/DeleteBankAccount' ,
      },
      User:{
        Insert: environment.notaServices + '/api/User/InsertNewUser' ,
        Update: environment.notaServices + '/api/User/UpdateUser' ,
        GetGrid: environment.notaServices + '/api/User/GetUserGrid' ,
        Get: environment.notaServices + '/api/User/GetUser',
        GetAllUserModules: environment.notaServices + '/api/User/GetAllUsermodules',
        GetUserModules: environment.notaServices + '/api/User/GetUserModules',
        UpdateUserModules: environment.notaServices + '/api/User/UpdateUserModules',
        UpdateUserZones: environment.notaServices + '/api/User/UpdateUserZones',
        GetUserZones: environment.notaServices + '/api/User/GetUserZoneList',
        GetUserDelegations : environment.notaServices + '/api/User/GetUserDelegationsList',
        UpdateUserDelegations: environment.notaServices + '/api/User/UpdateUserDelegations',
        UpdateUserServices :  environment.notaServices + '/api/User/UpdateUserServices',
        GetUserServicesList :environment.notaServices + '/api/User/GetUserServicesList',
        UpdateUserWarehouses :environment.notaServices + '/api/User/UpdateUserWarehouses',
        GetUserWarehouseList :environment.notaServices + '/api/User/GetUserWarehousesList',
        GetEnabledUserZones : environment.notaServices + '/api/User/GetEnabledUserZones',
        GetUserRoles : environment.notaServices + '/api/User/GetUserRoles',
        GetZonesList : environment.notaServices + '/api/User/GetZonesList',
        UpdateUserApps :environment.notaServices + '/api/User/UpdateUserApps',
        UpdateUserRoles :environment.notaServices + '/api/User/UpdateUserRoles',
        UpdateUserOperator :environment.notaServices + '/api/User/UpdateUserOperator',
        GetMenuList : environment.notaServices + '/api/User/GetMenuList',
        GetUserMenuList : environment.notaServices + '/api/User/GetUserMenuList',
        UpdateUserMenu : environment.notaServices + '/api/User/UpdateUserMenu',
        GetAllRoleList : environment.notaServices + '/api/User/GetAllRoleList'
      },
      IVA:{
        GetIVA: environment.notaServices + '/api/Iva/GetIVA',
        GetGrid: environment.notaServices + '/api/iva/getivagrid',
        GetRegulations: environment.notaServices + '/api/Iva/GetNormativasGrid',
        GetTaxTypeGrid: environment.notaServices + '/api/Iva/GetTaxTypeGrid',
        GetTaxType: environment.notaServices + '/api/Iva/GetTaxType',
        GetNormative: environment.notaServices + '/api/Iva/GetNormative',
        CreateTaxType: environment.notaServices + '/api/Iva/CreateTaxType',
        UpdateTaxType: environment.notaServices + '/api/Iva/UpdateTaxType',
        DeleteTaxType: environment.notaServices + '/api/Iva/DeleteTaxType',
        CreateNormative: environment.notaServices + '/api/Iva/CreateNormative',
        UpdateNormative: environment.notaServices + '/api/Iva/UpdateNormative',
        DeleteNormative: environment.notaServices + '/api/Iva/DeleteNormative',
        CreateIVA: environment.notaServices + '/api/Iva/CreateIva',
        DeleteIVA: environment.notaServices + '/api/Iva/DeleteIva',
        UpdateIVA: environment.notaServices + '/api/Iva/UpdateIva'
      }

    },
    ExternalBill: {
      PpfDetail: {
        GetListDetailPpfGrid: environment.notaServices + '/api/ExternalBill/PpfDetail/GetListDetailPpfGrid',
        SavePpfDetail: environment.notaServices + '/api/ExternalBill/PpfDetail/SavePpfDetail',
        CheckExistingPpf: environment.notaServices + '/api/ExternalBill/PpfDetail/CheckExistingPpf',
        GetPpf: environment.notaServices + '/api/ExternalBill/PpfDetail/GetPpf',
        GetPeriods: environment.notaServices + '/api/ExternalBill/PpfDetail/GetPeriods',
        GetServPeriods: environment.notaServices + '/api/ExternalBill/PpfDetail/GetServPeriods',
        Unblockppf: environment.notaServices + '/api/ExternalBill/PpfDetail/Unblockppf',
        DuplicateLinesToActualPeriod: environment.notaServices + '/api/ExternalBill/PpfDetail/DuplicateLinesToActualPeriod'
      },
      NewPpf: {
        GetStateList: environment.notaServices + '/api/ExternalBill/NewPpf/GetStateList',
        GetWorkTypeList: environment.notaServices + '/api/ExternalBill/NewPpf/GetWorkTypeList',
        GetWorkSubTypeList: environment.notaServices + '/api/ExternalBill/NewPpf/GetWorkSubTypeList',
        GetDebtTypeList: environment.notaServices + '/api/ExternalBill/NewPpf/GetDebtTypeList',
        SaveNewPpf: environment.notaServices + '/api/ExternalBill/NewPpf/SaveNewPpf',
        GetNewPpf: environment.notaServices + '/api/ExternalBill/NewPpf/GetNewPpf',
        GetHistStatesGrid: environment.notaServices + '/api/ExternalBill/NewPpf/GetHistStatesGrid',
        GetActivePeriod: environment.notaServices + '/api/ExternalBill/NewPpf/GetActivePeriod'
      },
      Coda: {
        GetCoda: environment.notaServices + '/api/ExternalBill/Coda/GetCoda',
        GetExternBillStateList: environment.notaServices + '/api/ExternalBill/Coda/GetExternBillStateList',
        SaveExternBillingDetail: environment.notaServices + '/api/ExternalBill/Coda/SaveExternBillingDetail',
        EmitExternBillingDetail: environment.notaServices + '/api/ExternalBill/Coda/EmitExternBillingDetail',
        GetBillingPaymentInfo: environment.notaServices + '/api/ExternalBill/Coda/GetBillingPaymentInfo',
        SaveBillingPayment: environment.notaServices + '/api/ExternalBill/Coda/SaveBillingPayment',
        GetListPayments: environment.notaServices + '/api/ExternalBill/Coda/GetListPayments',
        CheckCancelPaymentExternalBill: environment.notaServices + '/api/ExternalBill/Coda/CheckCancelPaymentExternalBill',
        CancelExternalBillingPayment: environment.notaServices + '/api/ExternalBill/Coda/CancelExternalBillingPayment',
        GetCodaPeriods: environment.notaServices + '/api/ExternalBill/Coda/GetCodaPeriods'
      }
    },
    gridReports: {
      GetBilling : environment.notaServices + '/api/GridReports/GetBilling',
      GetBudgets : environment.notaServices + '/api/GridReports/GetBudgets',
      GetAccountingDocs : environment.notaServices + '/api/GridReports/GetAccountingDocs',
      GetRemittance : environment.notaServices + '/api/GridReports/GetRemittance',
      GetPpfBill : environment.notaServices + '/api/GridReports/GetPpfBill'
    }
  },
  security: {
    // LOGIN
    Authenticate: environment.securityServices + '/api/Login/Authenticate',
    CreateToken: environment.securityServices + '/api/Login/CreateToken',
    AuthenticateUser: environment.securityServices + '/api/Login/AuthenticateUser',

    // USERS
    GetGridData: environment.securityServices + '/api/Login/GetGridData'
  },
  admin: {
    login: {
      GetToken: environment.adminServices + '/getToken'
    },
    common: {
      UserInfo: environment.adminServices + '/common/getUserInfo',
      GetMenuByUser: environment.adminServices + '/common/getMenuByUserId',
      GetStructure: environment.adminServices + '/common/getStructureOrganizational',
      GetStructureWO: environment.adminServices + '/common/getStructureOrganizationalWO'
    },
    configuration: {
      GetConfigurations: environment.adminServices + '/configuration/getConfigurations',
      GetConfigurationByIdExploitation: environment.adminServices + '/configuration/getConfigurationById',
      SaveConfiguration: environment.adminServices + '/configuration/saveConfiguration'
    },
    notif: {
      GetNotifications: environment.adminServices + '/notifications/getNotifications',
      getNotificationById: environment.adminServices + '/notifications/getNotificationById',
      sendNotification: environment.adminServices + '/notifications/sendNotification',
      sendSilenceNotification: environment.adminServices + '/notifications/sendSilenceNotification',
      loadUsers: environment.adminServices + '/notifications/loadUsers',
      loadUsersDevice: environment.adminServices + '/notifications/loadUsersDevices',
      validateTemplate: environment.adminServices + '/notifications/validatetemplate',
      sendNotificationByTemplate: environment.adminServices + '/notifications/sendnotifbytemplate',
    },
    remoteManagement: {
      GetBackupList: environment.adminServices + '/remoteManagement/getBackupList',
      DownloadBackup: environment.adminServices + '/remoteManagement/downloadBackup',
      ResendBackup: environment.adminServices + '/remoteManagement/resendBackup',
      SendNotifBackup: environment.adminServices + '/remoteManagement/sendNotifBackup',
      GetInstructionList: environment.adminServices + '/remoteManagement/getInstructionList',
      DownloadInstruction: environment.adminServices + '/remoteManagement/downloadInstruction',
      ResendInstruction: environment.adminServices + '/remoteManagement/resendInstruction',
      SendNotifInstruction: environment.adminServices + '/remoteManagement/sendNotifInstruction'
    }
  },
  api: {
    controlVersion: {
      GetVersions: environment.apiServices + '/AppVersions',
      GetAppCountries: environment.apiServices + '/AppCountries',
      DownloadAppInstaller: environment.apiServices + '/AppVersions/downloadAppInstaller',
      GetStatisticsVersions: environment.apiServices + '/StatisticsVersion/versions',
      GetInfoAccess: environment.apiServices + '/InfoAccess/usersDevices',
      GetInfoAccessDetail: environment.apiServices + '/InfoAccess/accessUserDetail',
      GetHistoricalAccess: environment.apiServices + '/InfoAccess/historicalAccessUser',
      GetHistoricalSynchroUser: environment.apiServices + '/InfoAccess/historicalSynchroUser',
      GetDevicesByUser: environment.apiServices + '/StatisticsVersion/devicesByUser',
      GetAppVersionQr: environment.apiServices + '/AppVersions/getAppVersionQR',
      GetDistributionGroups: environment.apiServices + '/AppDistributionGroup',
      CreateMultiVersions: environment.apiServices + '/AppVersions/createMultiCountry',
    }
  }
};
